import { Link } from "react-router-dom";
import { seoConfig } from "../data/seoConfig";

function normalizeBreadcrumbItem(item) {
  return {
    label: item.label || item.name,
    to: item.to || item.url
  };
}

function absoluteUrl(pathname = "/") {
  return `${seoConfig.baseUrl}${pathname === "/" ? "/" : pathname}`;
}

export function buildBreadcrumbSchema(items) {
  const normalizedItems = items.map(normalizeBreadcrumbItem).filter((item) => item.label && item.to);

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: normalizedItems.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: absoluteUrl(item.to)
    }))
  };
}

export default function Breadcrumbs({ items }) {
  const normalizedItems = items.map(normalizeBreadcrumbItem).filter((item) => item.label && item.to);

  return (
    <nav className="site-shell pt-5 text-sm" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-2 rounded-full border border-neutral-200 bg-white/80 px-4 py-2 text-neutral-500 shadow-sm backdrop-blur">
        {normalizedItems.map((item, index) => {
          const isCurrent = index === normalizedItems.length - 1;
          return (
            <li key={`${item.to}-${item.label}`} className="flex items-center gap-2">
              {index > 0 && <span className="text-neutral-300" aria-hidden="true">/</span>}
              {isCurrent ? (
                <span className="font-black text-neutral-950" aria-current="page">{item.label}</span>
              ) : (
                <Link to={item.to} className="font-semibold transition hover:text-blue-700">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
